import React, { Component } from "react";
import style from "./EditAccount.module.css";
import { Button } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import api from "../../utils/Api";
import history from "../../utils/history";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import { NAME_MESSAGE, NAME_REGEX } from "../../utils/RegexConstants";

export class EditAccount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      first_name: "",
      last_name: "",
      new_email: "",
      retype_new_email: "",
      new_password: "",
      retype_new_password: "",
      isEmailDisabled: false,
      isPasswordDisabled: false,
      isScreenLoaded: false,
      existingEmail:
        (localStorage.getItem("USER_INFO") &&
          JSON.parse(localStorage.getItem("USER_INFO")).email) ||
        "",
      oldPasswordError: "",
    };
  }

  componentDidMount() {
    document.title = 'Edit Account - TechToMedix';
    const userInfo = JSON.parse(localStorage.getItem("USER_INFO")).name;
    //console.log("userInfo", userInfo);
    let name = userInfo.split(" ");
    this.setState({
      first_name: name[0],
      last_name: name[1],
    });
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 2000);
  }

  handleInputChange = (event) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
    if (name === "new_email") {
      if (this.state.existingEmail == val) {
        // alert("Old and New Password cannot be same");
        this.setState({
          oldPasswordError: "Old and new email cannot be same",
        });
      } else {
        this.setState({
          oldPasswordError: "",
        });
      }
    }
  };

  handleEmailCheckChange = () => {
    this.setState((prevState) => ({
      isEmailDisabled: !prevState.isEmailDisabled,
    }));
  };

  // toggle password change
  handlePasswordCheckChange = () => {
    this.setState((prevState) => ({
      isPasswordDisabled: !prevState.isPasswordDisabled,
    }));
  };
  render() {
    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
    return (
      <React.Fragment>
        <Formik
          initialValues={this.state}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            first_name: Yup.string()
            .matches(NAME_REGEX, NAME_MESSAGE)
            .required("First Name is required"),
            last_name: Yup.string()
            .matches(NAME_REGEX, NAME_MESSAGE)
            .required("Last Name is required"),
            new_email: Yup.string().when("isEmailDisabled", {
              is: true,
              then: Yup.string()
                .email("Email is invalid")
                .required("Email is required"),
            }),
            retype_new_email: Yup.string().when("isEmailDisabled", {
              is: true,
              then: Yup.string()
                .email("Email is invalid")
                .required("Email is required")
                .oneOf([Yup.ref("new_email"), null], "email must match"),
            }),
            new_password: Yup.string().when("isPasswordDisabled", {
              is: true,
              then: Yup.string()
                .min(6, "Password must be at least 6 characters")
                .required("Password is required")
                .matches(
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#_%^*])/,
                  "Password must contain at least 1 lowercase, uppercase, numeric and special symbol."
                ),
            }),
            retype_new_password: Yup.string().when("isPasswordDisabled", {
              is: true,
              then: Yup.string()
                .oneOf([Yup.ref("new_password"), null], "Passwords must match")
                .required("Password is required"),
            }),
          })}
          onSubmit={async (data) => {
              this.setState({
                    errorMessage: "",
                  });
            if (this.state.oldPasswordError === "") {
              this.setState({
                isLoading: true,
              });
              // Paylaod
              const payload = {
                first_name: data.first_name,
                last_name: data.last_name,
                isChangeEmail: data.isEmailDisabled,
                email: data.new_email,
                isChangePassword: data.isPasswordDisabled,
                new_password: data.new_password,
                confirm_password: data.retype_new_password,
              };
             // console.log("Edit account payload", payload);

              // Headers
              const headers = {
                Authorization:
                  "Bearer " +
                  JSON.parse(localStorage.getItem("USER_INFO")).token,
              };

              try {
                const response = await api.put("user/edit", payload, {
                  headers: headers,
                });
                if (response.status === 200) {
                  this.setState({
                    isLoading: false,
                    successMessage:
                      "Account updated successfully! Please verify your email ",
                  });
                }
                setTimeout(() => {
                  this.setState({
                    successMessage: "",
                  });
                  localStorage.clear("USER_INFO");
                  history.push("/");
                }, 2500);
              } catch (error) {
                if (error.response) {
                  console.log("error.response", error.response);
                  this.setState({
                    isLoading: false,
                    errorMessage: error.response.data.message,
                  });
                  // setTimeout(() => {
                  //   this.setState({
                  //     errorMessage: "",
                  //   });
                  // }, 2000);
                }
              }
            }
          }}
          render={({ errors, status, touched }) => (
            <div className={style.editAccWrapper}>
              <div className="row">
                <div className="col-lg-12">
                  <h3>Edit Account</h3>
                </div>
                <div className="col-lg-12 intro-text">
                  <p className="mb-4">
                    Here the name, email and password can be changed as needed.
                    When the given checkbox is selected for email and password
                    sections, the fields will be enabled to edit the details.
                  </p>
                </div>
              </div>
              <Form>
                <div className="form-box-shadow mb-4">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4>User Info</h4>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label htmlFor="first_name">First Name</label>

                        <Field
                          name="first_name"
                          type="text"
                          className={
                            "form-control" +
                            (errors.first_name && touched.first_name
                              ? " is-invalid"
                              : "")
                          }
                          onChange={this.handleInputChange}
                        />
                        <ErrorMessage
                          name="first_name"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label htmlFor="last_name">Last Name</label>

                        <Field
                          name="last_name"
                          type="text"
                          className={
                            "form-control" +
                            (errors.last_name && touched.last_name
                              ? " is-invalid"
                              : "")
                          }
                          onChange={this.handleInputChange}
                        />
                        <ErrorMessage
                          name="last_name"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-box-shadow mb-4">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4>User Email Id</h4>
                      <div className="custom-control custom-checkbox mb-3">
                        <Field
                          type="checkbox"
                          className="custom-control-input"
                          id="change_email"
                          name="isEmailDisabled"
                          onChange={this.handleEmailCheckChange}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="change_email"
                        >
                          Change the user email id
                        </label>
                      </div>
                      <div>
                        <label htmlFor="existing email">
                          Existing email - {this.state.existingEmail}
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label htmlFor="new_email">Enter New Email Id:</label>

                        <Field
                          name="new_email"
                          type="text"
                          className={
                            "form-control" +
                            ((errors.new_email && touched.new_email) ||
                            this.state.oldPasswordError
                              ? " is-invalid"
                              : "")
                          }
                          onChange={this.handleInputChange}
                          disabled={!this.state.isEmailDisabled}
                        />
                        <ErrorMessage
                          name="new_email"
                          component="div"
                          className="invalid-feedback"
                        />
                        {this.state.oldPasswordError && (
                          <span className="error">
                            {this.state.oldPasswordError
                              ? this.state.oldPasswordError
                              : ""}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label htmlFor="retype_new_email">
                          Re-type New Email Id:
                        </label>

                        <Field
                          name="retype_new_email"
                          type="text"
                          className={
                            "form-control" +
                            (errors.retype_new_email && touched.retype_new_email
                              ? " is-invalid"
                              : "")
                          }
                          onChange={this.handleInputChange}
                          disabled={!this.state.isEmailDisabled}
                        />
                        <ErrorMessage
                          name="retype_new_email"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-box-shadow mb-2">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4>User Password</h4>
                    </div>
                    <div className="col-lg-12">
                      <div className="custom-control custom-checkbox mb-3">
                        <Field
                          type="checkbox"
                          className="custom-control-input"
                          id="change_password"
                          name="isPasswordDisabled"
                          onChange={this.handlePasswordCheckChange}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="change_password"
                        >
                          Change the user password
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label htmlFor="new_password">
                          Enter New Password:
                        </label>
                        <Field
                          name="new_password"
                          type="password"
                          className={
                            "form-control" +
                            (errors.new_password && touched.new_password
                              ? " is-invalid"
                              : "")
                          }
                          onChange={this.handleInputChange}
                          disabled={!this.state.isPasswordDisabled}
                        />
                        <ErrorMessage
                          name="new_password"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label htmlFor="retype_new_password">
                          Re-type New Password:
                        </label>
                        <Field
                          name="retype_new_password"
                          type="password"
                          className={
                            "form-control" +
                            (errors.retype_new_password &&
                            touched.retype_new_password
                              ? " is-invalid"
                              : "")
                          }
                          onChange={this.handleInputChange}
                          disabled={!this.state.isPasswordDisabled}
                        />
                        <ErrorMessage
                          name="retype_new_password"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    {this.state.isLoading ? (
                      <div className={style.loadingWrapper}>
                        <img src={ttmLoader} className={style.loading} />
                      </div>
                    ) : (
                      <div>
                        {this.state.successMessage && (
                          <p className={style.successMessage}>
                            {this.state.successMessage}
                          </p>
                        )}
                        {this.state.errorMessage && (
                          <p className={style.errorMessage}>
                            {this.state.errorMessage}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    <div className={style.editAccBtnWrapper}>
                      {/* <Button type="button" className="form-primary-btn">
                        Cancel
                      </Button> */}
                      <Button type="submit" className="form-primary-btn">
                        Save
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        />
      </React.Fragment>
    );
  }
}

export default EditAccount;
